import { gql } from "@apollo/client";
import { ProductCardFieldsFragment } from "@govlaunch/product";

export default gql`
  query SearchProducts($tags: [String!], $name: String, $limit: Int, $cursor: Cursor) {
    searchProducts(tags: $tags, name: $name, limit: $limit, cursor: $cursor) {
      items {
        ...ProductCardFields
      }
      pageInfo {
        startCursor
        endCursor
        hasPreviousPage
        hasNextPage
      }
    }
  }

  ${ProductCardFieldsFragment}
`;
